/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const CogIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g id="nav" stroke="none" fill="none">
      <path d="M19.5661667,13.375 L22.5416667,13.375 L22.5416667,10.625 L19.56525,10.625 C19.3736667,9.83025 19.0601667,8.62575 18.6458333,7.9465 L20.7505,5.84275 L18.15725,3.2495 L16.0516667,5.35416667 C15.3733333,4.93983333 14.16975,4.62725 13.375,4.43566667 L13.375,1.45833333 L10.625,1.45833333 L10.625,4.43566667 C9.83025,4.62725 8.62575,4.93983333 7.94741667,5.35416667 L5.84183333,3.2495 L3.24858333,5.84275 L5.35416667,7.94741667 C4.93983333,8.62575 4.62633333,9.83025 4.43383333,10.625 L1.45833333,10.625 L1.45833333,13.375 L4.43383333,13.375 C4.62633333,14.16975 4.93983333,15.37425 5.35416667,16.0525833 L3.24858333,18.1581667 L5.84183333,20.7505 L7.9465,18.6449167 C8.62575,19.0610833 9.83025,19.3736667 10.625,19.5661667 L10.625,22.5416667 L13.375,22.5416667 L13.375,19.5661667 C14.16975,19.3736667 15.37425,19.0601667 16.0516667,18.6458333 L18.1581667,20.7505 L20.7505,18.1581667 L18.6458333,16.0525833 C19.0601667,15.37425 19.3736667,14.16975 19.5661667,13.375 Z" />
      <circle cx="12" cy="12" r="4.125" />
    </g>
  </svg>
);

export default CogIcon;
